
(function clickOnceModuleDefinition() {

    angular.module('ClickOnce', []);

})();